export default class SteeringModeEnum {
  static MODIFIED = 'MODIFIED';
  static OPTIMIZED = 'OPTIMIZED';
}
